import { AdditionalRequestState } from "../dataTypes";

export const sessionSliceName = "session";

export interface SessionState extends AdditionalRequestState {
  isInitialized: null | boolean;
  JWT: null | string;
}
